import { Link, useLocation, Outlet } from 'react-router-dom';
import { useAdminStore } from '../../../store/adminStore';

export default function AdminLayout() {
  const location = useLocation();
  const { logout } = useAdminStore();

  const menuItems = [
    { icon: 'ri-dashboard-line', label: 'Dashboard', path: '/admin/dashboard' },
    { icon: 'ri-product-hunt-line', label: 'Ürünler', path: '/admin/products' },
    { icon: 'ri-slideshow-line', label: 'Slider', path: '/admin/sliders' },
    { icon: 'ri-image-line', label: 'Halı Kombinleri', path: '/admin/banners' },
    { icon: 'ri-book-open-line', label: 'Katalog', path: '/admin/catalog' },
    { icon: 'ri-article-line', label: 'Blog Yazıları', path: '/admin/blog' },
    { icon: 'ri-gallery-line', label: 'Fabrika Galerisi', path: '/admin/gallery' },
    { icon: 'ri-menu-line', label: 'Menü Ayarları', path: '/admin/menu-settings' },
    { icon: 'ri-palette-line', label: 'Logo Ayarları', path: '/admin/logo-settings' },
    { icon: 'ri-pages-line', label: 'Sayfalar', path: '/admin/pages' },
    { icon: 'ri-contacts-line', label: 'İletişim', path: '/admin/contact' },
  ];

  const handleLogout = () => {
    logout();
    window.location.href = '/admin/login';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <aside className="w-64 bg-gray-900 text-white flex flex-col fixed top-0 left-0 h-screen z-40">
        <div className="p-6 border-b border-gray-800">
          <h1 className="text-xl font-bold">Admin Panel</h1>
          <p className="text-sm text-gray-400 mt-1">Yönetim Paneli</p>
        </div>

        <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 cursor-pointer ${
                  isActive
                    ? 'bg-[#D4AF37] text-black font-semibold'
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`}
              >
                <i className={`${item.icon} text-xl`}></i>
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-gray-800 space-y-2">
          <a
            href="https://toptan.ticimedya.xyz"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-blue-600 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-store-2-line text-xl"></i>
            <span>Bayi Paneline Git</span>
          </a>
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-gray-700 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-external-link-line text-xl"></i>
            <span>Siteye Git</span>
          </a>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-red-600 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-logout-box-line text-xl"></i>
            <span>Çıkış Yap</span>
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto ml-64">
        <Outlet />
      </main>
    </div>
  );
}